import Vue from 'vue';
import Vuex from 'vuex';
import vorbasse from './vorbasse';
import ux from './ux'

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		vorbasse,
		ux
	},
});

export default store
